import { useCustomMutate, useCustomQuery } from '../../hooks/query';
import { Configs } from '../../models';
import {
  getConfig,
  getIExamBirthCountryCode,
  getIExamConfig,
  getIExamCountryCode,
  postConfig,
  postIExamConfig,
} from './api';
import {
  CONFIG_KEY_GET_BIRTH_COUNTRY_CODE,
  CONFIG_KEY_GET_CONFIG,
  CONFIG_KEY_GET_COUNTRY_CODE,
  CONFIG_KEY_GET_IEXAM_CONFIG,
  CONFIG_KEY_POST_CONFIG,
  CONFIG_KEY_UPDATE_IEXAM_CONFIG,
} from './key';
import { IExamMasterCodeItem, NonExamMasterCodeItem, UpdateConfigRequest } from './model';
import { transformConfig } from './transformer';

export const useConfigQuery = () =>
  useCustomQuery<Configs>(
    CONFIG_KEY_GET_CONFIG,
    () => getConfig().then((res) => transformConfig(res.data)),
    { refetchOnWindowFocus: false }
  );

export const useConfigUpdateMutation = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate<any, UpdateConfigRequest[]>(CONFIG_KEY_POST_CONFIG, postConfig, {
    onSuccess,
    onError,
  });

export const useIExamConfigQuery = () =>
  useCustomQuery<any>(CONFIG_KEY_GET_IEXAM_CONFIG, () => getIExamConfig().then((res) => res.data), {
    refetchOnWindowFocus: false,
  });

export const useIExamConfigMutation = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate<any>(CONFIG_KEY_UPDATE_IEXAM_CONFIG, postIExamConfig, {
    onSuccess,
    onError,
  });

export const useIExamCountryCodeQuery = () =>
  useCustomQuery<IExamMasterCodeItem>(
    CONFIG_KEY_GET_COUNTRY_CODE,
    () => getIExamCountryCode().then((res) => res.data),
    {
      staleTime: Infinity,
    },
    false,
    false
  );

export const useIExamBirthCountryCodeQuery = () =>
  useCustomQuery<NonExamMasterCodeItem[]>(
    CONFIG_KEY_GET_BIRTH_COUNTRY_CODE,
    () => getIExamBirthCountryCode().then((res) => res.data),
    {
      staleTime: Infinity,
    },
    false,
    false
  );
